<template>
  <div class="yhc-kazai-detail-input--select-kazai-type">
    <div class="yhc-kazai-detail-input--select-kazai-type--inner">
      <div class="card yhc-sub-card">
        <div class="card-header">お荷物の種類</div>
        <div class="card-body">
          <div class="yhc-kazai-detail-input--select-kazai-type--list">
            <div
              v-for="kazai in kazaiTypes"
              class="yhc-kazai-detail-input--select-kazai-type--list-item card yhc-sub-card border-0"
              :class="{ active: kazai.id === currentKazaiId }"
            >
              <div
                class="yhc-kazai-detail-input--select-kazai-type--list-item--inner"
                @click.prevent="$emit('selectKazaiType', kazai.id)"
              >
                <div class="yhc-kazai-detail-input--select-kazai-type--list-item--name">
                  {{ kazai.name }}
                </div>
                <div
                  v-if="kazai.displayNameFormEnabled"
                  class="yhc-kazai-detail-input--select-kazai-type--list-item--input-item-name mb-2"
                >
                  <input
                    type="text"
                    class="form-control"
                    :class="{
                      'border border-danger': !userInputName,
                    }"
                    :value="userInputName"
                    placeholder="お荷物の名称"
                    @change="
                      ($event) => $emit('updateUserInputName', $event.target.value)
                    "
                  />
                  <div
                    class="small text-danger"
                    v-if="!userInputName"
                  >
                    入力必須です
                  </div>
                </div>
                <div
                  class="yhc-kazai-detail-input--select-kazai-type--list-item--img"
                  v-if="kazai.thumbnail"
                >
                  <img
                    class="w-100"
                    v-if="kazai.thumbnail"
                    :src="$core.$imgix.buildUrl(kazai.thumbnail, { w: 980 })"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="receptionDisabledKazaiTypes.length > 0 && !isKaguidoOption"
          class="yhc-ef-kazai-detail--reception-disabled-notice"
        >
          <div class="disabled-notice-text mb-2">
            <img src="/images/icons/warning-yellow.svg" />
            <span class="txt bold ml-2">以下の家財については荷受けできません。</span>
          </div>
          <ul class="mb-0">
            <li
              v-for="kazaiType in receptionDisabledKazaiTypes"
              :key="kazaiType.id"
              class="bold"
            >
              {{ kazaiType.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.yhc-kazai-detail-input--select-kazai-type--list {
  display: grid;
  flex-wrap: wrap;
  width: 100%;
  gap: var(--yhc-base-pad);
  justify-content: center;
  grid-template-columns: repeat(auto-fit, 150px);

  @media screen and (max-width: 400px) {
    grid-template-columns: repeat(auto-fit, 140px);
  }
  .yhc-kazai-detail-input--select-kazai-type--list-item {
    &.active {
      outline: 4px solid var(--yhc-color);
      background-color: var(--yhc-color-green-light);
    }
    > .yhc-kazai-detail-input--select-kazai-type--list-item--inner {
      cursor: pointer;
      padding: var(--yhc-base-pad-sm) var(--yhc-base-pad) var(--yhc-base-pad);
      .yhc-kazai-detail-input--select-kazai-type--list-item--name {
        font-size: 0.9em;
        text-align: center;
        padding-bottom: var(--yhc-base-pad-sm);
        font-weight: bold;
      }
    }
  }
}

.yhc-ef-kazai-detail--reception-disabled-notice {
  padding: var(--yhc-base-pad);
  border-top: 1px dashed #c6c9d3;

  .txt {
    display: inline-block;
    //margin-left: var(--yhc-base-pad-sm);
  }
}
</style>

<script lang="ts">
import { PropType } from 'vue'
import { ModelYhcKazaiTypesFullRelation } from '../../../../fireModels/yhcDataTypes'

export default {
  props: {
    isKaguidoOption: {
      type: Boolean,
      default: false,
    },
    kazaiTypes: {
      type: Array as PropType<ModelYhcKazaiTypesFullRelation[]>,
      required: true,
    },
    currentKazaiId: {
      type: Number,
      required: true,
    },
    userInputName: {
      type: String,
      required: false,
    },
    receptionDisabledKazaiTypes: {
      type: Array as PropType<ModelYhcKazaiTypesFullRelation[]>,
      required: true,
    },
  },
}
</script>
